<template>
	<div class="addMain">
		<el-form :model="form" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-row>
				<el-col :span="4">平台名称</el-col>
				<el-col :span="20">
					<el-input v-model="form.platform.name" disabled></el-input>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4">设备编号</el-col>
				<el-col :span="20">
					<el-input v-model="form.deviceSid"></el-input>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {

				},
			
				
			}
		},
		
	}
</script>

<style scoped>
	.addMain .el-row{
		display: flex;
		align-items: center;
	}
	.addMain .el-row:first-of-type{
		margin-bottom:20px;
	}
	.addMain .el-select{
		width:100%;
	}
	.addMain .el-option{
		width:100%;
	}
</style>
